export default "__VITE_ASSET__771e48e3__"